/**
 * Classic DataTables–style sort affordances for all Vuetify index tables:
 * every sortable column shows a muted dual-arrow; the active sort column
 * uses a directional arrow (styled via index-table-sort.scss).
 */
export const vuetifyIndexTableDefaults = {
  VDataTable: {
    sortIcon: 'mdi-swap-vertical',
    sortAscIcon: 'mdi-arrow-up',
    sortDescIcon: 'mdi-arrow-down',
  },
  VDataTableServer: {
    sortIcon: 'mdi-swap-vertical',
    sortAscIcon: 'mdi-arrow-up',
    sortDescIcon: 'mdi-arrow-down',
  },
  VDataTableVirtual: {
    sortIcon: 'mdi-swap-vertical',
    sortAscIcon: 'mdi-arrow-up',
    sortDescIcon: 'mdi-arrow-down',
  },
}
